/**
 * Raccoglie il porting di alcune funzioni di WordPress.
 */

/**
 * Questo è un porting incompleto della funzione `wp_strip_all_tags()` di WordPress.
 *
 * @param {string} text
 * @returns {string}
 */
function wp_strip_all_tags(text) {
    return text.replace(/(<([^>]+)>)/gi, "");
}

/**
 * Questo è un porting incompleto della funzione `wp_trim_words()` di WordPress.
 *
 * Non sono considerate le lingue che utilizzano ideogrammi e che quindi devono tagliare il testo in base ai
 * caratteri, piuttosto delle parole.
 *
 * Il testo restituito non viene passato al filtro `wp_trim_words`.
 *
 * @param {string} text
 * @param {string|int} num_words
 * @param {string} more
 * @returns {string}
 */
function wp_trim_words(text, num_words = 55, more = null) {
    if (null === more) {
        more = '&hellip;';
    }

    text = wp_strip_all_tags(text);
    num_words = parseInt(num_words, 10);

    let words_array = text.split(/[\n\r\t ]+/);

    if (words_array.length > num_words) {
        words_array = words_array.slice(0, num_words);
        return words_array.join(" ") + more;
    } else {
        return words_array.join(" ");
    }
}

export {
    wp_strip_all_tags,
    wp_trim_words
};
